module.exports = __webpack_public_path__ + "static/img/标志中英文反白.91f9b47.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/标志中英文反白.png
// module id = kvDX
// module chunks = 1